import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPin = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.250 8.250 A3.750 3.750 0 1 0 15.750 8.250 A3.750 3.750 0 1 0 8.250 8.250 Z",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12,.75a7.5,7.5,0,0,1,7.5,7.5c0,3.407-5.074,11.95-6.875,14.665a.75.75,0,0,1-1.25,0C9.574,20.2,4.5,11.657,4.5,8.25A7.5,7.5,0,0,1,12,.75Z",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})]
});
export default SvgPin;
